import React from "react";

import { useBaseBreadcrumb } from "./helpers";
import { Breadcrumbs } from "../Breadcrumbs";
import { BreadcrumbItem } from "../types";
import { BreadcrumbsSchema } from "./BreadcrumbsSchema";

export interface LandingBreadcrumbsProps {
  breadcrumbItems?: BreadcrumbItem[];
}

const LandingBreadcrumbs: React.FC<LandingBreadcrumbsProps> = ({ breadcrumbItems }) => {
  const baseBreadcrumbItems = useBaseBreadcrumb();
  const items = baseBreadcrumbItems.concat(breadcrumbItems!);
  return (
    <>
      <Breadcrumbs breadcrumbItems={items} />
      <BreadcrumbsSchema breadcrumbItems={items} />
    </>
  );
};

LandingBreadcrumbs.defaultProps = {
  breadcrumbItems: []
};

export { LandingBreadcrumbs };
